import { Injectable } from '@angular/core';
import { BehaviorSubject, filter } from 'rxjs';
import { VersionService } from './version.service';
import { UserDeviceService } from './user-device.service';
import { DeviceTypeEnum } from '../../account-activity';

@Injectable({
	providedIn: 'root'
})
export class ReleaseNoteService {
	private showNewVersionSub: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public showNewVersion$ = this.showNewVersionSub.asObservable();

	constructor(
		private versionService: VersionService,
		private userDeviceService: UserDeviceService
	) {
		this.userDeviceService.deviceType$
			.pipe(filter((a: any) => a !== DeviceTypeEnum.Unknown))
			.subscribe(deviceType => {
				this.detectAppNewVersion(deviceType);
			});
	}

	desktopShowUpdate = false;
	mobileShowUpdate = false;

	desktopTitles = [
		'بروزرسانی ۱۴۰۳/۰۲/۰۴'
		// 'بروزرسانی ۱۴۰۱/۰۳/۲۸'
		// ۰۱۲۳۴۵۶۷۸۹
	];

	desktopUpdateLists: { title: string; changes: string[] }[][] = [
		[
			{
				title: 'مفید کارت',
				changes: ['افزایش سقف برداشت آنی به ۲۰۰ میلیون تومان', 'اضافه شدن قابلیت مسدود سازی مفید کارت']
			}
		]
	];
	mobileTitles = [
		'بروزرسانی ۱۴۰۳/۰۲/۰۴'
		// 'بروزرسانی ۱۴۰۱/۰۳/۲۸'
		// ۰۱۲۳۴۵۶۷۸۹
	];

	mobileUpdateLists: { title: string; changes: string[] }[][] = [
		[
			{
				title: 'مفید کارت',
				changes: ['افزایش سقف برداشت آنی به ۲۰۰ میلیون تومان', 'اضافه شدن قابلیت مسدود سازی مفید کارت']
			}
		]
	];

	detectAppNewVersion(deviceType: DeviceTypeEnum) {
		if (
			((deviceType === DeviceTypeEnum.Desktop && this.desktopShowUpdate) ||
				(deviceType === DeviceTypeEnum.Mobile && this.mobileShowUpdate)) &&
			this.versionService.isNewVersion()
		) {
			this.changeShowNewVersion(true);
		} else {
			if (this.versionService.isNewVersion()) {
				this.versionService.setCurrentVersion();
			}
		}
	}

	changeShowNewVersion(state: boolean) {
		this.showNewVersionSub.next(state);
	}

	closeReleaseNote() {
		this.changeShowNewVersion(false);
		this.versionService.setCurrentVersion();
	}
}
